(() => {
class PtcProductCarousel {
  constructor(element) {
    this.track = element.querySelector('[data-carousel-track]');
    this.previous = element.querySelector('[data-carousel-prev]');
    this.next = element.querySelector('[data-carousel-next]');
    this.current = element.querySelector('[data-carousel-current]');
    this.total = element.querySelector('[data-carousel-total]');
    this.status = element.querySelector('.ptc-product-carousel__status');
    if (!this.track || !this.previous || !this.next) return;

    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.track);
    this.observeCards();
    window.addEventListener('load', () => this.update(), { once: true });
    this.updateAfterLayout();
  }

  observeCards() {
    [...this.track.children].forEach((card) => this.resizeObserver.observe(card));
  }

  refresh() {
    if (!this.track || !this.resizeObserver) return;
    this.observeCards();
    this.updateAfterLayout();
  }

  move(direction) {
    const cards = [...this.track.children];
    if (!cards.length) return;
    const cardWidth = cards[0].getBoundingClientRect().width;
    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const step = Math.max(1, cardWidth + gap);
    this.track.scrollTo({ left: this.track.scrollLeft + (step * direction), behavior: 'smooth' });
  }

  updateAfterLayout() {
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => this.update()));
  }

  update() {
    const cards = [...this.track.children];
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const atStart = this.track.scrollLeft <= 2;
    const cardWidth = cards[0]?.getBoundingClientRect().width || 1;
    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const currentIndex = Math.min(cards.length, Math.max(1, Math.round(this.track.scrollLeft / (cardWidth + gap)) + 1));
    const progress = cards.length ? (currentIndex / cards.length) * 100 : 0;
    if (this.current) this.current.textContent = String(currentIndex).padStart(2, '0');
    if (this.total) this.total.textContent = String(cards.length).padStart(2, '0');
    if (this.status) this.status.style.setProperty('--ptc-carousel-progress', `${progress}%`);
    this.previous.disabled = atStart;
    this.next.disabled = cards.length < 2 || (!atStart && maximum > 2 && this.track.scrollLeft >= maximum - 2);
  }
}

const initializeCarousels = (scope = document) => scope.querySelectorAll?.('[data-product-carousel]').forEach((element) => {
  if (element.dataset.carouselReady === 'true') return;
  element.dataset.carouselReady = 'true';
  element.ptcProductCarousel = new PtcProductCarousel(element);
});

initializeCarousels();
document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
document.addEventListener('ptc:product-cards-updated', (event) => event.detail?.section?.ptcProductCarousel?.refresh());
})();
